<script lang="ts">
  /**
   * @typedef {Object} Props
   * @property {string} [containerTag]
   * @property {string} [containerStyle]
   * @property {string} [containerClass]
   * @property {string} [svgStyle]
   * @property {string} [fill]
   * @property {string} [loaderType]
   * @property {number} [width]
   * @property {number} [height]
   */

  /** @type {Props} */
  let {
    containerTag = "div",
    containerStyle = "",
    containerClass = "",
    svgStyle = "",
    fill = "currentColor",
    loaderType = "bounce",
    width = 120,
    height = 30
  } = $props();
</script>

<svelte:element this={containerTag} class="{containerClass}" style="{containerStyle}">
{#if loaderType === "bounce"}

<!-- By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL -->
<svg width={width} height={height} viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill="{fill}" style={svgStyle}>
    <circle cx="15" cy="15" r="15">
        <animate attributeName="r" from="15" to="15"
                 begin="0s" dur="0.8s"
                 values="15;9;15" calcMode="linear"
                 repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="1" to="1"
                 begin="0s" dur="0.8s"
                 values="1;.5;1" calcMode="linear"
                 repeatCount="indefinite" />
    </circle>
    <circle cx="60" cy="15" r="9" fill-opacity="0.3">
        <animate attributeName="r" from="9" to="9"
                 begin="0s" dur="0.8s"
                 values="9;15;9" calcMode="linear"
                 repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="0.5" to="0.5"
                 begin="0s" dur="0.8s"
                 values=".5;1;.5" calcMode="linear"
                 repeatCount="indefinite" />
    </circle>
    <circle cx="105" cy="15" r="15">
        <animate attributeName="r" from="15" to="15"
                 begin="0s" dur="0.8s"
                 values="15;9;15" calcMode="linear"
                 repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="1" to="1"
                 begin="0s" dur="0.8s"
                 values="1;.5;1" calcMode="linear"
                 repeatCount="indefinite" />
    </circle>
</svg>

{/if}

{#if loaderType === "leftToRight"}
<svg style={svgStyle} width={width} height={height} version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 30" enable-background="new 0 0 0 0" xml:space="preserve">
    <circle fill="{fill}" stroke="none" cx="6" cy="10" r="6">
      <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"></animate>
    </circle>
    <circle fill="{fill}" stroke="none" cx="26" cy="10" r="6">
      <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"></animate>
    </circle>
    <circle fill="{fill}" stroke="none" cx="46" cy="10" r="6">
      <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"></animate>
    </circle>
  </svg>
{/if}
</svelte:element>
